import React from "react";

const SystemAssistantBody = () => (
  <div className="nmv-assistant-body">
    <p className="nmv-assistant-intro">
      I'm here to help you create accurate vouchers.<br />Here are my suggestions:
    </p>

    <div className="nmv-assistant-section-title">Smart Suggestions</div>

    <div className="nmv-suggestion-card green">
      <div className="nmv-suggestion-icon green">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="11" fill="#f6ffed" stroke="#52c41a" strokeWidth="1.5" />
          <path d="M8 12.5L11 15.5L16.5 9" stroke="#52c41a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </div>
      <div className="nmv-suggestion-content">
        <div className="nmv-suggestion-title">Amounts are balanced</div>
        <div className="nmv-suggestion-desc">Great! Your total amount matches the payment amount.</div>
      </div>
    </div>

    <div className="nmv-suggestion-card orange">
      <div className="nmv-suggestion-icon orange">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="11" fill="#fff7e6" stroke="#faad14" strokeWidth="1.5" />
          <circle cx="12" cy="8" r="1.2" fill="#faad14" />
          <rect x="11" y="10.5" width="2" height="6" rx="1" fill="#faad14" />
        </svg>
      </div>
      <div className="nmv-suggestion-content">
        <div className="nmv-suggestion-title">Frequently used</div>
        <div className="nmv-suggestion-desc">
          You often pay ABC Supplies Ltd. Consider marking as favorite.
        </div>
        <button className="nmv-outline-btn blue">Add to Favorites</button>
      </div>
    </div>

    <div className="nmv-suggestion-card orange">
      <div className="nmv-suggestion-icon orange">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="11" fill="#fff7e6" stroke="#faad14" strokeWidth="1.5" />
          <circle cx="12" cy="8" r="1.2" fill="#faad14" />
          <rect x="11" y="10.5" width="2" height="6" rx="1" fill="#faad14" />
        </svg>
      </div>
      <div className="nmv-suggestion-content">
        <div className="nmv-suggestion-title">Possible duplicate?</div>
        <div className="nmv-suggestion-desc">
          Similar payment of $ 8,250.00 was made on 02/05/2024 to ABC Supplies Ltd.
        </div>
        <button className="nmv-outline-btn blue">View Previous Voucher</button>
      </div>
    </div>

    <div className="nmv-assistant-divider" />

    <div className="nmv-assistant-section-title">Need Help?</div>

    <div className="nmv-help-links">
      <div className="nmv-help-link">
        <span className="nmv-help-icon">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10.5" stroke="#bfbfbf" strokeWidth="1.5" />
            <path d="M9.5 9.5C9.5 8.12 10.62 7 12 7C13.38 7 14.5 8.12 14.5 9.5C14.5 10.88 13.38 12 12 12V13.5" stroke="#bfbfbf" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="12" cy="16.5" r="1" fill="#bfbfbf" />
          </svg>
        </span>
        What is the difference between Payment and Receipt?
      </div>
      <div className="nmv-help-link">
        <span className="nmv-help-icon">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10.5" stroke="#bfbfbf" strokeWidth="1.5" />
            <path d="M9.5 9.5C9.5 8.12 10.62 7 12 7C13.38 7 14.5 8.12 14.5 9.5C14.5 10.88 13.38 12 12 12V13.5" stroke="#bfbfbf" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="12" cy="16.5" r="1" fill="#bfbfbf" />
          </svg>
        </span>
        When should I use 'Apply To All Lines'?
      </div>
      <div className="nmv-help-link">
        <span className="nmv-help-icon">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10.5" stroke="#bfbfbf" strokeWidth="1.5" />
            <path d="M9.5 9.5C9.5 8.12 10.62 7 12 7C13.38 7 14.5 8.12 14.5 9.5C14.5 10.88 13.38 12 12 12V13.5" stroke="#bfbfbf" strokeWidth="1.5" strokeLinecap="round" />
            <circle cx="12" cy="16.5" r="1" fill="#bfbfbf" />
          </svg>
        </span>
        How does Cash In Transit work?
      </div>
    </div>

    <button className="nmv-help-center-btn">
      View Help Center
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
        <path d="M3.5 8.5L8.5 3.5M8.5 3.5H4.5M8.5 3.5V7.5" stroke="#1890ff" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </button>
  </div>
);

export const SystemAssistantSidebar = ({ showAssistant, onClose }) => {
  if (!showAssistant) return null;
  return (
    <div className="nmv-assistant">
      <div className="nmv-assistant-header">
        <div className="nmv-assistant-title">
          <span className="nmv-assistant-icon">✦</span>
          <span>System Assistant</span>
        </div>
        <button className="nmv-assistant-collapse" onClick={onClose}>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2.5 7.5L6 4L9.5 7.5" stroke="#8c8c8c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </button>
      </div>
      <SystemAssistantBody />
    </div>
  );
};

export const SystemAssistantDrawerContent = ({ onClose }) => (
  <div className="nmv-assistant nmv-assistant-drawer">
    <div className="nmv-assistant-header">
      <div className="nmv-assistant-title">
        <span className="nmv-assistant-icon">✦</span>
        <span>System Assistant</span>
      </div>
      <button className="nmv-assistant-collapse" onClick={onClose}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d="M2.5 7.5L6 4L9.5 7.5" stroke="#8c8c8c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </button>
    </div>
    <SystemAssistantBody />
  </div>
);

export default SystemAssistantBody;
